/* global powerbi */
import React, { useEffect } from "react";
import * as pbi from "powerbi-client";
import { getPowerBiEmbedToken } from "../helpers/apiRequests";
import LoadingAnimation from "./vacancies/loadingAnimation/loadingAnimation";
import { setDisplayOnElement } from "../helpers/traversingDom";

let report; // holds reference to embedded report
let reportUpdateInterval; // for storing setInterval ref so can clear on unmount

const reportConfiguration = (embedToken, companyRef, pageId) => ({
  type: "report",
  id: process.env.REACT_APP_REPORT_ID,
  embedUrl: "https://app.powerbi.com/reportEmbed",
  tokenType: pbi.models.TokenType.Embed,
  accessToken: embedToken,
  pageName: pageId,
  viewMode: pbi.models.ViewMode.View,
  permissions: pbi.models.Permissions.Read,
  settings: {
    filterPaneEnabled: false,
    navContentPaneEnabled: false,
    background: pbi.models.BackgroundType.Transparent
  },
  filters: [
    {
      $schema: "http://powerbi.com/product/schema#basic",
      target: {
        table: "pab_Client_Ref",
        column: "Client_Name"
      },
      operator: "In",
      values: [companyRef]
    }
  ]
});

const updateReportEmbedToken = tokenStore =>
  getPowerBiEmbedToken(tokenStore.getToken()).then(embedToken =>
    report.setAccessToken(embedToken)
  );

const scheduleEmbedTokenRefresh = tokenStore => {
  reportUpdateInterval = setInterval(
    () => updateReportEmbedToken(tokenStore),
    1000 * 60 * 4 // update token every 4 minutes
  );
};

const embedReport = (tokenStore, companyRef, pageId) =>
  getPowerBiEmbedToken(tokenStore.getToken())
    .then(embedToken => {
      const reportElement = document.getElementById("report");
      setDisplayOnElement(reportElement, "none");
      report = powerbi.load(
        reportElement,
        reportConfiguration(embedToken, companyRef, pageId)
      );
      report.on("loaded", () => {
        setDisplayOnElement(
          document.getElementsByClassName("loading-animation__container")[0],
          "none"
        );
        setDisplayOnElement(reportElement, "block");
        report.render();
      });

      scheduleEmbedTokenRefresh(tokenStore);
    })
    .catch(() => {
      setDisplayOnElement(
        document.getElementsByClassName("loading-animation__container")[0],
        "none"
      );
      setDisplayOnElement(
        document.getElementsByClassName("report-failureMessage")[0],
        "block"
      );
    });

const ReportEmbedContainer = () => (
  <div className="report-container">
    <div id="report" className="powerbiReport" />
  </div>
);

const ReportWrapper = props => (
  <div>
    <div className="report-failureMessage">Failed to load data</div>
    <ReportLoader {...props} />
    <ReportEmbedContainer />
  </div>
);

const ReportLoader = ({ tokenStore, companyRef, pageId }) => {
  useEffect(() => {
    embedReport(tokenStore, companyRef, pageId);
    return () => clearInterval(reportUpdateInterval);
  }, []);

  return <LoadingAnimation />;
};

export default ReportWrapper;
